import { Component, OnInit } from '@angular/core';
import { PublicacionService } from '../../core/publicacion.service';
import { AuthService } from '../../core/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog} from '@angular/material';
import { EditarpubComponent } from '../editarpub/editarpub.component';
import { EliminarpubComponent } from '../eliminarpub/eliminarpub.component';


@Component({
  selector: 'app-mispublicaciones',
  templateUrl: './mispublicaciones.component.html',
  styleUrls: ['./mispublicaciones.component.css']
})
export class MispublicacionesComponent implements OnInit {

  publicaciones;
  userState;
  userid;

  id: string;

  dialogResult;


  constructor(public dialog: MatDialog, private activatedRoute: ActivatedRoute, public authService: AuthService, private publicacionService: PublicacionService) {
    this.activatedRoute.params.forEach((urlParameters) => {
      this.id = urlParameters['id'];
      // this.item = this.getItem(this.id).subscribe(item => this.item = item)
    });
  }

  openDialogEditar(publicacion) {
    let dialogRef = this.dialog.open(EditarpubComponent, {
      // width: '600px',
      data: publicacion,
      panelClass: 'my-full-screen-dialog',
      // autoFocus: fa
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
      this.dialogResult = result;
    });
  }
  openDialogEliminar(publicacion) {
    let dialogRef = this.dialog.open(EliminarpubComponent, {
      // width: '600px',
      panelClass: 'my-full-screen-dialog',
      data: publicacion
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
      this.dialogResult = result;
    });
  }

  ngOnInit() {
    this.publicaciones = this.publicacionService.getMySnapshot(this.id);

    // this.userState = this.authService.user.map(user => {
    //   if (user) {
    //     this.userid = user.uid;
    //   }
    // })

    // this.authService.user.map(user => {
    //   if (user) {
    //     console.log(user.uid)
    //     this.userid = user.uid;
    //   }
    // })

    // console.log(this.userid)


    // console.log(this.userid);


    // setTimeout(() => {
    //   this.publicaciones = this.publicacionService.getMySnapshot(this.userid);
    // }, 4000);
  }

}



// WEBPACK FOOTER //
// ./src/app/publicaciones/mispublicaciones/mispublicaciones.component.ts